import actionTypes from 'SRC/modules/redux/actionTypes'

export const setActiveTip = tip => ({
  type: actionTypes.SET_ACTIVE_TIP,
  payload: tip
})
